var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-indigo-500 px-16 py-12"},[_c('div',{staticClass:"max-w-5xl mx-auto space-y-8"},[_c('h3',{staticClass:"text-white"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }